import clsx from 'clsx';
import { Container } from '~/components/Container';
import type { PromoBanner } from '~/types/custom';
import { getMaskedPathSync } from '~/utils/url';

export function Banner(props: PromoBanner) {
  // console.log(props);
  if (!props?.bannerImage?.node?.sourceUrl) return null;

  return (
    <div
      id={props?.id ?? 'banner'}
      className={clsx(
        'items-start justify-start self-stretch px-[--site-margin] py-8 lg:py-4',
        props?.className,
      )}
    >
      <Container className="overflow-hidden">
        {props.bannerLink?.url ? (
          <a
            href={props.bannerLink.url}
            target={props.bannerLink.target ?? undefined}
            className="mx-auto inline-block"
          >
            <img
              className="hidden w-full object-contain md:block"
              src={getMaskedPathSync(
                props.bannerImage.node.sourceUrl,
                props?.team ?? undefined,
              )}
              alt={props.bannerImage.node.altText ?? ''}
            />
            {props.mobileBannerImage?.node?.sourceUrl && (
              <img
                className="block w-full object-contain md:hidden"
                src={getMaskedPathSync(
                  props.mobileBannerImage.node.sourceUrl,
                  props?.team ?? undefined,
                )}
                alt={props.mobileBannerImage.node.altText ?? ''}
              />
            )}
          </a>
        ) : (
          <div className="mx-auto inline-block">
            <img
              className="hidden w-full object-contain md:block"
              src={getMaskedPathSync(
                props.bannerImage.node.sourceUrl,
                props?.team ?? undefined,
              )}
              alt={props.bannerImage.node.altText ?? ''}
            />
            {props.mobileBannerImage?.node?.sourceUrl && (
              <img
                className="block w-full object-contain md:hidden"
                src={getMaskedPathSync(
                  props.mobileBannerImage.node.sourceUrl,
                  props?.team ?? undefined,
                )}
                alt={props.mobileBannerImage.node.altText ?? ''}
              />
            )}
          </div>
        )}
      </Container>
    </div>
  );
}
